import { isVisitorInChina, getBreakpoint, setSkipLink } from './_utils';
import floorPlanViewer from './_floorPlanViewer';
import { attachAnalyticsEvents } from '../analytics/map-and-floorplan';

const componentName = 'MapAndFloorplan';
const classes = {
	active: `${componentName}-button--active`,
	hidden: `${componentName}-button--hidden`,
	container: 'container',
	row: 'row',
	columns: 'col-lg-12',
};
const selectors = {
	baseComponent: `.${componentName}`,
	virtualTour: `.${componentName}-virtualTour`,
	view360: `.${componentName}-view360`,
	map: '.EmbeddedMap-map',
	contentContainer: `.${componentName}-container`,
	contentRow: `.${componentName}-row`,
	contentColumns: `.${componentName}-column`,
	button: `.${componentName}-button`,
};

const $contentContainer = $(selectors.contentContainer);
const $contentRow = $(selectors.contentRow);
const $contentColumns = $(selectors.contentColumns);

const getButtonSelector = (target, id) => {
	return id
		? `${selectors.button}[data-target="${target}"][data-component="${id}"]`
		: `${selectors.button}[data-target="${target}"]`;
};

const getComponentSelector = (selector, id) => {
	return id ? `${selector}[data-component="${id}"]` : `${selector}[data-component]`;
};

const getComponentId = $element => $element && $element.data('component');
const getComponentTarget = $element => $element && $element.data('target');

const showSelected = ($button, id, target) => {
	const baseComponent = selectors.baseComponent;
	const componentSelector = getComponentSelector('', id);
	const $section = $(`${baseComponent} [data-section="${target}"]${componentSelector}`);
	const $select = $(`${baseComponent} select${componentSelector}`);
	const $prevBtn = $(`${baseComponent} button${componentSelector}`).not($button);
	const $prevSection = $(`${baseComponent} [data-section]${componentSelector}`).not($section);

	$button.addClass(classes.active);
	$section.removeClass(classes.hidden).show();

	$prevBtn.removeClass(classes.active);
	$prevSection.hide().addClass(classes.hidden);

	$select.val(target);
};

const setInitialState = () => {
	let $button;
	let id;

	if (isVisitorInChina()) {
		$button =
			$(getButtonSelector('360-view')).length > 0
				? $(getComponentSelector(selectors.button)).eq(1)
				: $(getComponentSelector(selectors.button)).eq(0);
		id = getComponentId($button);
		hideMapAnd360(id);
	} else {
		$button = $(getComponentSelector(selectors.button)).eq(0);
		id = getComponentId($button);
	}

	const target = getComponentTarget($button);

	showSelected($button, id, target);
};

const hideMapAnd360 = id => {
	const labelMap = 'map';
	const label360 = '360-view';
	const labelVT = 'virtual-tour';
	const labelFloorplan = 'floor-plan';
	const $mapBtn = $(getButtonSelector(labelMap, id));
	const $360Btn = $(getButtonSelector(label360, id));
	const $floorplanBtn = $(getButtonSelector(labelFloorplan, id));
	const $virtualTourBtn = $(getButtonSelector(labelVT, id));
	const $select = $(`select[data-component="${id}"]`);
	const $optionMap = $select.find(`option[value="${labelMap}"]`);
	const $option360 = $select.find(`option[value="${label360}"]`);

	if ($360Btn.length > 0) {
		$360Btn.parent().hide();
		$option360.remove();
	}

	if ($floorplanBtn.length > 0 || $virtualTourBtn.length > 0) {
		$(selectors.baseComponent).show();
	}

	$mapBtn.parent().hide();
	$optionMap.remove();
};

const setMapHeight = () => {
	let contentHeight;
	const $virtualTour = $(selectors.virtualTour);
	const $view360 = $(selectors.view360);
	let imageTab;
	if ($virtualTour.length) {
		imageTab = $virtualTour;
	} else {
		imageTab = $view360;
	}
	const $mapSelector = $(`.${componentName}`).find(selectors.map);

	if (imageTab.is(':hidden')) {
		imageTab.show();
		contentHeight = imageTab.height();
		imageTab.hide();
	} else {
		contentHeight = imageTab.height();
	}

	$mapSelector.height(contentHeight);
};

const handleButtonClick = event => {
	const $button = $(event.target);
	const isNotActive = !$button.hasClass(classes.active);

	if (isNotActive) {
		const id = getComponentId($button);
		const target = getComponentTarget($button);

		setMapHeight();
		showSelected($button, id, target);
	}
};

const handleDropdownChange = event => {
	const $selected = $(event.target);
	const target = $selected.val();
	const id = getComponentId($selected);
	const $button = $(getButtonSelector(target, id));

	if ($button.length) {
		setMapHeight();
		showSelected($button, id, target);
	}
};

const toggleGridClasses = () => {
	if (getBreakpoint() === 'large' || getBreakpoint() === 'xlarge') {
		$contentContainer.addClass(classes.container);
		$contentRow.addClass(classes.row);
		$contentColumns.addClass(classes.columns);
	} else {
		$contentContainer.removeClass(classes.container);
		$contentRow.removeClass(classes.row);
		$contentColumns.removeClass(classes.columns);
	}
	setMapHeight();
};

export default function init() {
	const baseComponent = $(selectors.baseComponent);
	if (baseComponent.length > 0) {
		setInitialState();
		setSkipLink(baseComponent);
		floorPlanViewer();

		baseComponent.find('button[data-target]').click(handleButtonClick);
		baseComponent.find('select[data-component]').change(handleDropdownChange);

		if (!isVisitorInChina()) {
			$(selectors.baseComponent).show();
			setMapHeight();
			$(window).on('resize', setMapHeight);
		}

		toggleGridClasses();
		$(window).on('resize', toggleGridClasses);

		attachAnalyticsEvents(baseComponent);
	}
}
